/* reflect-metadata has to be imported first */
/* eslint-disable import/order */

import 'reflect-metadata';
import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import '@core/model/framework/extensions/index';
import {
  bindAngularDependenciesToCoreAndMapToAngularProvider,
  coreDependenciesToAngularProviderMapper,
} from 'src/conf/di/angularProviderMapper';
import { Kernel } from '@di/kernel';
import { buildConfiguration } from 'src/conf/di/kernelConfiguration';
import { environment } from '@environments/environment';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxTagCommanderModule, WindowRef } from 'ngx-tag-commander';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { CacheInterceptor } from './app/core/interceptor/cache-interceptor';

const kernelConfiguration = buildConfiguration();
const kernel = Kernel.initialize(kernelConfiguration);

if (environment.production) {
  enableProdMode();
}

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      CommonModule,
      NgxTagCommanderModule,
      FormsModule,
      ReactiveFormsModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    WindowRef,
    coreDependenciesToAngularProviderMapper(kernel),
    bindAngularDependenciesToCoreAndMapToAngularProvider(kernel),
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
